import { useState } from 'react';

const SupplierModel = () => {
  const initialState = {
    id: 0,
    supplierName: '',
  };
  const [supplier, setSupplier] = useState(initialState);
  return {
    supplier,
    setSupplier,
    initialState,
  };
};
export default SupplierModel;
